module.exports = __webpack_public_path__ + "static/media/Angela_Ferrari_13.6ae988af.jpg";